import { Internal } from './Internal';
import { MGS } from './MGS';


export const Header = {
  Internal,
  MGS,
};
